import {Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter} from '@angular/core'
import { ModalService } from 'src/app/services/ui/modal.service'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import {SnotifyService} from "ng-snotify";
import {HamiltonService} from "../../../services/hamilton/hamilton.service";

@Component({
    selector: 'monitor-detalhes-modal',
    templateUrl: './detalhes-modal.component.html',
    styleUrls: ['./detalhes-modal.component.scss']
})
export class DetalhesModalComponent implements OnInit {

    /**
     * Define se o modal é visível.
     */
    @Input() public isVisible = false

    /**
     * Define se a resolução é visível.
     */
    @Input() public resolucaoIsVisible = false

    /**
     * Define se o stack trace é visível.
     */
    @Input() public stackTraceIsVisible = false

    /**
     * Textarea dos detalhes
     */
    @ViewChild('detalhesTxtArea') detalhesTxtArea: ElementRef;

    /**
     * Id do modal
     * @type {string}
     */
    @Input() public idModal:string = 'modal'

    /**
     * Dados do Report
     */
    @Input() public reportData = null

    /**
     * Dados do Cliente
     */
    @Input() public clientData = null

    /**
     * Dados do Report Solucionado
     */
    @Output() outputResolutionReport = new EventEmitter<any>()

    /**
     * Dados da Stack Traces
     */
    public stackTracesData = []

    public appNomes = [
        '--',
        'NFE',
        'CTE',
        'NFSE',
        'MDFE',
        'NFCE',
        'CONCESSIONARIA',
        'PORTAL',
        'GNRE',
        'GESTAO_DESEMPENHO'
    ]

    public form = new FormGroup({
        resolucaoDetalhes: new FormControl('', Validators.required)
    });

    constructor(
        private modalService: ModalService,
        private hamiltonService: HamiltonService,
        private _notify: SnotifyService
    ) { }

    ngOnInit() {
        this.modalService.isVisible.subscribe((isVisible: boolean) => {
            this.isVisible = isVisible
        })
    }

    clear(): void {
        this.form.reset()
    }

    /**
     * Funcionalidade de fechar o modal.
     */
    closeModal() {
        this.resolucaoIsVisible = false
        this.stackTraceIsVisible = false
        this.stackTracesData = []
        this.modalService.isVisible.next(false)
    }

    setDataModal(reportData, clientData) {
        if(reportData != '' && clientData != '') {
            this.reportData = reportData
            this.clientData = clientData
            return true
        }
        return false
    }

    /**
     * Exibir ou ocultar form de resolucao
     */
    openResolucao() {
        this.stackTraceIsVisible = false
        this.resolucaoIsVisible = !this.resolucaoIsVisible
        setTimeout(() => {
            this.detalhesTxtArea.nativeElement.focus();
        }, 0);
    }

    /**
     * Exibir ou ocultar o Stack Trace
     */
    openStackTrace() {
        this.stackTraceIsVisible = !this.stackTraceIsVisible
        if(this.stackTracesData.length == 0) {
            this.getStackTraces()
        }
    }

    /**
     * Consultar Stack Traces
     */
    getStackTraces() {
        if(this.reportData != null) {
            this.hamiltonService.getStackTraces(this.reportData.id).subscribe((data) => {
                if(data.data.stackTraces.length > 0)
                    this.stackTracesData = data.data.stackTraces
                else
                    this.stackTracesData = null
            }, error => {
                this._notify.error('Falha ao consultar os Stack Traces')
                return false
            });
        }
    }

    resetAll()
    {
        this.reportData = null
        this.clientData = null
        this.isVisible = false
        this.stackTracesData = null
    }

    submitResolution() {
        if(this.reportData != null && this.clientData != null) {
            if(this.form.status == 'VALID')
            {
                let submitData = {
                    report_id: this.reportData.id,
                    resolved_message: this.form.get('resolucaoDetalhes').value
                }

                this.hamiltonService.postResolveReport(submitData).subscribe(()=> {
                    let msgNotificacao = 'Resolução do caso #'+this.reportData.id+', de '+this.clientData.name+' registrado com sucesso!'
                    this.outputResolutionReport.emit({client_id: this.clientData.id, report_id: this.reportData.id});
                    this._notify.success(msgNotificacao)
                    this.resetAll()
                }, error => {
                    this._notify.error('Houve um erro ao registrar a resolução');
                })

            }
        }
    }
}
